const apiUrl = process.env.REACT_APP_API_URL;
export const DeleteStock = async ( id: number , page : string ) => {
    try {
        const response = await fetch(`${apiUrl}:8072/stock`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({id})
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};